import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

// localStorage key for the session token (Griffin staff portal only).
// This is the same value the backend sets as the `session_token` cookie.
// We dual-track in localStorage because iOS Safari / Chrome on iPhone can
// reject or partition `SameSite=None` cookies set during a cross-site OAuth
// redirect (auth.emergentagent.com → griffinpulse.com). Sending it as an
// Authorization: Bearer header makes login work even when the cookie is
// blocked.
export const SESSION_TOKEN_KEY = "griffin_session_token";

export function setSessionToken(token) {
  if (!token) return;
  try { localStorage.setItem(SESSION_TOKEN_KEY, token); } catch (_) { /* private mode */ }
}
export function clearSessionToken() {
  try { localStorage.removeItem(SESSION_TOKEN_KEY); } catch (_) { /* ignore */ }
}
export function getSessionToken() {
  try { return localStorage.getItem(SESSION_TOKEN_KEY); } catch (_) { return null; }
}

const api = axios.create({
  baseURL: API,
  withCredentials: true,
});

// Attach the session token (if we have one) to every request as a fallback
// for browsers that block our session cookie.
api.interceptors.request.use((config) => {
  const t = getSessionToken();
  if (t && !config.headers?.Authorization) {
    config.headers = { ...(config.headers || {}), Authorization: `Bearer ${t}` };
  }
  return config;
});

// On 401, wipe the stale token so we don't keep sending it forever.
api.interceptors.response.use(
  (r) => r,
  (err) => {
    if (err?.response?.status === 401) {
      clearSessionToken();
    }
    throw err;
  },
);

export default api;
